/* eslint-disable */
import {
  Box,
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
  Paper,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { Cancel, Save } from "@mui/icons-material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { saveEnvioAnteojoArreglo } from "../../services/EnvioAnteojoArregloService.js";
import { format } from "date-fns";
import { v4 as uuidv4 } from 'uuid';
import EnvioAnteojoArregloDialog from "./EnvioAnteojoArregloDialog.jsx";
import Message from "../../utils/Message.jsx";
import WaitingDialog from "../../utils/WaitingDialog";

const initialEnvioAnteojoArregloData = {
  fechaRegistracion: format(new Date(), "dd/MM/yyyy"),
  observaciones: "",
};
//
// ###########################################################################
//
const EnvioAnteojoArregloNew = () => {
  const navigate = useNavigate();
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [envioAnteojoArregloData, setEnvioAnteojoArregloData] = useState(
    initialEnvioAnteojoArregloData
  );
  const [envioAnteojoArregloItems, setEnvioAnteojoArregloItems] = useState([]);
  const [anteojoArregloItem, setAnteojoArregloItem] = useState({});
  const [openAnteojoArregloDialog, setOpenAnteojoArregloDialog] = useState(false);
  const [actionCrud, setActionCrud] = useState("");
  const [openQuitarAnteojoArregloDialog, setOpenQuitarAnteojoArregloDialog] = useState(false);

  const tableColumns = [
    {
      field: "descripcion_corta_area_destino",
      headerName: "Sucursal de destino",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_corta_area_destino;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "codigo_anteojo_arreglo",
      headerName: "Código Ant/Arr",
      headerAlign: "center",
      flex: 1,
      minWidth: 120,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_anteojo_arreglo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "codigo_gc",
      headerName: "Código GC",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_gc;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "anteojo_arreglo",
      headerName: "Anteojo/Arreglo",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.anteojo_arreglo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cliente_nombre_apellido",
      headerName: "Cliente",
      headerAlign: "center",
      flex: 1,
      minWidth: 300,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cliente_nombre_apellido;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      width: 200,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: 'left',
      renderCell: (params) => (
        <Tooltip title="Iniciar">
          <IconButton
            size="small"
            aria-label="iniciar"
            onClick={() => handleClickActionCrud(params.row, "delete")}
          >
            <RemoveCircleOutlineIcon />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setEnvioAnteojoArregloData({
      ...envioAnteojoArregloData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ##########################################################################
  //
  const handleSave = () => {
    if (envioAnteojoArregloItems.length === 0) {
      setMessage({
        messageText: "No se han registrado Anteojos/Arreglos para enviar",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }
    save();
  };
  //
  // ################################################################################
  //
  const save = async () => {
    let _envioAnteojoArregloObject = {
      observaciones: envioAnteojoArregloData.observaciones,
      envio_anteojo_arreglo_list: envioAnteojoArregloItems.map((item) => ({
        id_area_destino: item.id_area_destino,
        tipo: item.anteojo_arreglo.toLowerCase(),
        id_gc_anteojo_arreglo: item.id_gc_anteojo_arreglo,
        notas: item.notas,
      })),
    };

    console.log("---");
    console.log("in ");
    console.log("envioAnteojoArregloData");
    console.log(_envioAnteojoArregloObject);
    console.log();

    setIsDoingSomething(true);
    const response = await saveEnvioAnteojoArreglo(_envioAnteojoArregloObject);
    setIsDoingSomething(false);

    if (response.ok) {
      setMessage({
        messageText: "Envío de Anteojos/Arreglos guardado",
        severity: "success",
      });
      setShowMessage(true);
      setTimeout(() => {
        handleCancelar();
      }, 1000);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ##########################################################################
  //
  const handleCancelar = () => {
    navigate("/envio-anteojo-arreglo-table");
  };
  //
  // ##########################################################################
  //
  const handleClickActionCrud = (parAnteojoArreglo, parAction) => {
    setActionCrud(parAction);
    setAnteojoArregloItem(parAnteojoArreglo);
    if (parAction === "new") {
      setOpenAnteojoArregloDialog(true);
    } else {
      setOpenQuitarAnteojoArregloDialog(true);
    }
  };
  //
  // ################################################################################
  //
  const handleSaveDialog = (parAnteojoArreglo, parAction) => {
    if (parAction === "new") {
      const _yaAgregado = envioAnteojoArregloItems.some(
        (item) => item.id_gc_anteojo_arreglo === parAnteojoArreglo.idGcAnteojoArreglo
      );

      if (_yaAgregado) {
        setMessage({
          messageText:
            "El Anteojo/Arreglo " +
            parAnteojoArreglo.codigoAnteojoArreglo +
            " ya se encuentra agregado a este Envío de Anteojos/Arreglos",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      setEnvioAnteojoArregloItems([
        ...envioAnteojoArregloItems,
        {
          id: uuidv4(),
          bandeja: parAnteojoArreglo.bandeja,
          codigo_anteojo_arreglo: parAnteojoArreglo.codigoAnteojoArreglo,
          codigo_gc: parAnteojoArreglo.codigoGC,
          anteojo_arreglo: parAnteojoArreglo.tipoAnteojoArreglo,
          id_gc_anteojo_arreglo: parAnteojoArreglo.idGcAnteojoArreglo,
          id_area_destino: parAnteojoArreglo.idAreaDestino,
          descripcion_area_destino: parAnteojoArreglo.descripcionAreaDestino,
          descripcion_corta_area_destino: parAnteojoArreglo.descripcionCortaAreaDestino,
          cliente_nombre_apellido: parAnteojoArreglo.clienteNombreApellido,
          notas: parAnteojoArreglo.notas,
        },
      ]);
    } else if (parAction === "delete") {
      const _envioAnteojoArregloItems = envioAnteojoArregloItems.filter(
        (item) => item.id_gc_anteojo_arreglo !== parAnteojoArreglo.id_gc_anteojo_arreglo
      );
      setEnvioAnteojoArregloItems(_envioAnteojoArregloItems);
      setOpenQuitarAnteojoArregloDialog(false);
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    setOpenAnteojoArregloDialog(false);
  };
  //
  // ################################################################################
  //
  return (
    <Box sx={{
      m: 1, p: 2,
      pt: 2,
      border: "1px solid LightGrey",
      borderRadius: "5px",
      backgroundColor: "primary",
    }}
      className="box-table"
    >
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={2} >
          <Box sx={{ p: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography variant="h5" display="block" gutterBottom>
                  Nuevo Envío de Anteojos / Arreglos
                </Typography>
              </Grid>
            </Grid>

            <Grid container sx={{ mt: 1 }}>
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    maxLength: 3,
                  }}
                  id="fechaRegistracion"
                  label="Fecha de Registración"
                  variant="outlined"
                  size="small"
                  name="fechaRegistracion"
                  value={envioAnteojoArregloData.fechaRegistracion}
                  InputProps={{ readOnly: true }}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={0} sm={0} md={6} lg={6}></Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  sx={{
                    "& .MuiInputBase-root": {
                      minHeight: "80px",
                      minWidth: "400px",
                    },
                  }}
                  id="observaciones"
                  label="Observaciones"
                  variant="outlined"
                  name="observaciones"
                  value={envioAnteojoArregloData.observaciones}
                  onChange={handleChange}
                  InputProps={{
                    autoComplete: "off",
                  }}
                  multiline
                  rows={3}
                  fullWidth
                />
              </Grid>

              <Grid item xs={0} sm={0} md={6} lg={6}></Grid>
            </Grid>

            <Grid container sx={{ mt: 1, mb: 1 }}>
              <Grid item xs={12} md={2} lg={2}>
                <Button
                  // className="btn-add"
                  variant="contained"
                  onClick={() => handleClickActionCrud({}, "new")}
                  startIcon={<AddCircleOutlineOutlinedIcon />}
                >
                  Agregar Anteojo/Arreglo
                </Button>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ border: "1px solid LightGrey", mb: 2, p: 1, borderRadius: "5px" }}>
            <Typography variant="subtitle1" sx={{ mt: 1, ml: 1 }}>
              Anteojos/Arreglos a enviar
            </Typography>
            <DataGrid
              rows={envioAnteojoArregloItems}
              columns={tableColumns}
              {...tableOptions}
            />
          </Box>

          <Box sx={{ m: 1, p: 1 }}>
            <Grid container spacing={1} justifyContent="flex-end">
              <Grid item xs={12} md={2} lg={1}>
                <Button
                  sx={{ mr: 1, width: "100%" }}
                  variant="contained"
                  startIcon={<Save />}
                  onClick={handleSave}
                >
                  Guardar
                </Button>
              </Grid>

              <Grid item xs={12} md={2} lg={1}>
                <Button
                  sx={{ mr: 1, width: "100%" }}
                  variant="outlined"
                  onClick={handleCancelar}
                  startIcon={<Cancel />}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Paper>

      {/* >>> dialog para agregar Anteojo/Arreglo */}

      {openAnteojoArregloDialog && (
        <EnvioAnteojoArregloDialog
          actionCrud={actionCrud}
          anteojoArregloItem={anteojoArregloItem}
          onSave={handleSaveDialog}
          onClose={handleCloseDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      <Dialog
        open={openQuitarAnteojoArregloDialog}
        PaperProps={{
          sx: {
            backgroundColor: "white",
            borderRadius: 2,
          },
        }}
        onClose={() => setOpenQuitarAnteojoArregloDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ color: "black" }}>
          Atención
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" sx={{ color: "black" }}>
            ¿Estás seguro de quitar el Anteojo/Arreglo de este envío?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              color: "white",
              backgroundColor: "#3f81c4",
              borderColor: "#3f81c4",
              borderWidth: 1,
              borderStyle: "solid",
              "&:hover": {
                backgroundColor: "#e3f2fd",
                color: "#3f81c4",
              },
            }}
            onClick={() => handleSaveDialog(anteojoArregloItem, "delete")}
            autoFocus
          >
            Sí
          </Button>
          <Button
            sx={{
              color: "#3f81c4",
              backgroundColor: "white",
              borderColor: "#3f81c4",
              borderWidth: 1,
              borderStyle: "solid",
              "&:hover": {
                backgroundColor: "#e3f2fd",
              },
            }}
            onClick={() => setOpenQuitarAnteojoArregloDialog(false)}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      {/* >>>> Messages */}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}

      <WaitingDialog open={isDoingSomething} />
    </Box>
  );
};
export default EnvioAnteojoArregloNew;
